export const applicantDashboardConstants = {

  RESET_ACTION: "RESET_ACTION",
  
  //get applicant profile
  GET_APPLICANT_HIRING_PROGRESS_ACTION_REQUEST:
    "GET_APPLICANT_HIRING_PROGRESS_ACTION_REQUEST",
  GET_APPLICANT_HIRING_PROGRESS_ACTION_SUCCESS:
    "GET_APPLICANT_HIRING_PROGRESS_ACTION_SUCCESS",
  GET_APPLICANT_HIRING_PROGRESS_ACTION_FAILURE:
    "GET_APPLICANT_HIRING_PROGRESS_ACTION_FAILURE",

  //get applicant profile
  GET_APPLICANT_PROFILE_ACTION_REQUEST: "GET_APPLICANT_PROFILE_ACTION_REQUEST",
  GET_APPLICANT_PROFILE_ACTION_SUCCESS: "GET_APPLICANT_PROFILE_ACTION_SUCCESS",
  GET_APPLICANT_PROFILE_ACTION_FAILURE: "GET_APPLICANT_PROFILE_ACTION_FAILURE",

  //get applicant profile
  GET_APPLICANT_PROFILE_INTERVIEW_VIDEOS_ACTION_REQUEST:
    "GET_APPLICANT_PROFILE_INTERVIEW_VIDEOS_ACTION_REQUEST",
  GET_APPLICANT_PROFILE_INTERVIEW_VIDEOS_ACTION_SUCCESS:
    "GET_APPLICANT_PROFILE_INTERVIEW_VIDEOS_ACTION_SUCCESS",
  GET_APPLICANT_PROFILE_INTERVIEW_VIDEOS_ACTION_FAILURE:
    "GET_APPLICANT_PROFILE_INTERVIEW_VIDEOS_ACTION_FAILURE",

  //get applicant profile
  GET_APPLICANT_SUBMITTED_ASSESSMENT_KITS_ACTION_REQUEST:
    "GET_APPLICANT_SUBMITTED_ASSESSMENT_KITS_ACTION_REQUEST",
  GET_APPLICANT_SUBMITTED_ASSESSMENT_KITS_ACTION_SUCCESS:
    "GET_APPLICANT_SUBMITTED_ASSESSMENT_KITS_ACTION_SUCCESS",
  GET_APPLICANT_SUBMITTED_ASSESSMENT_KITS_ACTION_FAILURE:
    "GET_APPLICANT_SUBMITTED_ASSESSMENT_KITS_ACTION_FAILURE",

  // update applicant profile
  UPDATE_APPLICANT_HIRING_PROGRESS_ACTION_REQUEST:
    "UPDATE_APPLICANT_HIRING_PROGRESS_ACTION_REQUEST",
  UPDATE_APPLICANT_HIRING_PROGRESS_ACTION_SUCCESS:
    "UPDATE_APPLICANT_HIRING_PROGRESS_ACTION_SUCCESS",
  UPDATE_APPLICANT_HIRING_PROGRESS_ACTION_FAILURE:
    "UPDATE_APPLICANT_HIRING_PROGRESS_ACTION_FAILURE",

  // get comments list
  GET_COMMENTS_LIST_ACTION_REQUEST: "GET_COMMENTS_LIST_ACTION_REQUEST",
  GET_COMMENTS_LIST_ACTION_SUCCESS: "GET_COMMENTS_LIST_ACTION_SUCCESS",
  GET_COMMENTS_LIST_ACTION_FAILURE: "GET_COMMENTS_LIST_ACTION_FAILURE",

  // create comments
  CREATE_COMMENT_ACTION_REQUEST: "CREATE_COMMENT_ACTION_REQUEST",
  CREATE_COMMENT_ACTION_SUCCESS: "CREATE_COMMENT_ACTION_SUCCESS",
  CREATE_COMMENT_ACTION_FAILURE: "CREATE_COMMENT_ACTION_FAILURE",

  // delete  comments
  DELETE_COMMENT_ACTION_REQUEST: "DELETE_COMMENT_ACTION_REQUEST",
  DELETE_COMMENT_ACTION_SUCCESS: "DELETE_COMMENT_ACTION_SUCCESS",
  DELETE_COMMENT_ACTION_FAILURE: "DELETE_COMMENT_ACTION_FAILURE",

  // update  comments
  UPDATE_COMMENT_ACTION_REQUEST: "UPDATE_COMMENT_ACTION_REQUEST",
  UPDATE_COMMENT_ACTION_SUCCESS: "UPDATE_COMMENT_ACTION_SUCCESS",
  UPDATE_COMMENT_ACTION_FAILURE: "UPDATE_COMMENT_ACTION_FAILURE",

  // update  comments
  GET_APPLICANT_HMS_VIDEOS_ACTION_REQUEST: "GET_APPLICANT_HMS_VIDEOS_ACTION_REQUEST",
  GET_APPLICANT_HMS_VIDEOS_ACTION_SUCCESS: "GET_APPLICANT_HMS_VIDEOS_ACTION_SUCCESS",
  GET_APPLICANT_HMS_VIDEOS_ACTION_FAILURE: "GET_APPLICANT_HMS_VIDEOS_ACTION_FAILURE",

  // update  comments
  CREATE_APPLICANT_OFFER_TERMS_ACTION_REQUEST: "CREATE_APPLICANT_OFFER_TERMS_ACTION_REQUEST",
  CREATE_APPLICANT_OFFER_TERMS_ACTION_SUCCESS: "CREATE_APPLICANT_OFFER_TERMS_ACTION_SUCCESS",
  CREATE_APPLICANT_OFFER_TERMS_ACTION_FAILURE: "CREATE_APPLICANT_OFFER_TERMS_ACTION_FAILURE",

  // update  comments
  GET_APPLICANT_OFFER_TERMS_ACTION_REQUEST: "GET_APPLICANT_OFFER_TERMS_ACTION_REQUEST",
  GET_APPLICANT_OFFER_TERMS_ACTION_SUCCESS: "GET_APPLICANT_OFFER_TERMS_ACTION_SUCCESS",
  GET_APPLICANT_OFFER_TERMS_ACTION_FAILURE: "GET_APPLICANT_OFFER_TERMS_ACTION_FAILURE",
  // update  comments
  UPDATE_APPLICANT_OFFER_TERMS_ACTION_REQUEST: "UPDATE_APPLICANT_OFFER_TERMS_ACTION_REQUEST",
  UPDATE_APPLICANT_OFFER_TERMS_ACTION_SUCCESS: "UPDATE_APPLICANT_OFFER_TERMS_ACTION_SUCCESS",
  UPDATE_APPLICANT_OFFER_TERMS_ACTION_FAILURE: "UPDATE_APPLICANT_OFFER_TERMS_ACTION_FAILURE",
  // update  comments
  DELETE_APPLICANT_OFFER_TERMS_ACTION_REQUEST: "DELETE_APPLICANT_OFFER_TERMS_ACTION_REQUEST",
  DELETE_APPLICANT_OFFER_TERMS_ACTION_SUCCESS: "DELETE_APPLICANT_OFFER_TERMS_ACTION_SUCCESS",
  DELETE_APPLICANT_OFFER_TERMS_ACTION_FAILURE: "DELETE_APPLICANT_OFFER_TERMS_ACTION_FAILURE",
};

